import type { MarketGroup } from './types';

export interface MarketNavigationItem {
  key: string;
  id?: string;
  name?: string;
  path?: string;
  children?: MarketNavigationItem[];
  tag?: string | null;
}

export default function groupMarketsBySector(markets: MarketGroup[]): MarketNavigationItem[] {
  return markets.map(sectorName => ({
    key: sectorName.name,
    name: sectorName.name,
    path: `/markets/sector/${sectorName.name}`,

    children: sectorName.markets.map(
      ({ name, marketId, comingSoon, tag }): MarketNavigationItem => {
        return {
          key: name + marketId,
          id: marketId,
          name,
          path: `/markets/${marketId}`,
          ...(comingSoon ? { tag: 'Coming Soon' } : { tag })
        };
      }
    )
  }));
}
